export default {
  // Navbar
  'nav.home': 'Home',
  'nav.about': 'Chi Siamo',
  'nav.services': 'Servizi',
  'nav.contracts': 'Contratti',
  'nav.profit': 'Profitto',
  'nav.video': 'Video',
  'nav.invest': 'INVESTI ORA',

  // Hero
  'hero.badge': 'Elon Musk · SpaceX · IPO 2025',
  'hero.title1': 'INVESTI NEL',
  'hero.title2': 'FUTURO',
  'hero.desc': 'Contratti di investimento esclusivi nell\'IPO SpaceX di Elon Musk. Rendimenti dal <strong>20% al 50%</strong> in soli <strong>2 giorni lavorativi</strong>. Contratti da <strong>3 000 €</strong>.',
  'hero.cta.primary': 'SCEGLI CONTRATTO',
  'hero.cta.secondary': 'Scopri di più',
  'hero.stat1': 'Max. Rendimento',
  'hero.stat2': 'Top Contratto',
  'hero.stat3': 'Anno IPO',

  // About
  'about.tag': 'Chi è SpaceX IPO',
  'about.title1': 'L\'AZIENDA DEL',
  'about.title2': 'FUTURO',
  'about.p1': 'SpaceX è l\'azienda aerospaziale di Elon Musk che ha rivoluzionato il settore spaziale. La prima azienda privata ad aver portato astronauti sulla ISS, creatrice di Starlink e del razzo interplanetario Starship.',
  'about.p2': 'L\'IPO SpaceX è un evento storico che apre la possibilità di diventare azionista di un\'azienda valutata oltre <strong>$200 miliardi</strong>. I nostri pacchetti permettono di entrare con soglie minime e rendimenti garantiti in soli <strong>2 giorni lavorativi</strong>.',
  'about.fact1': 'Valutazione SpaceX',
  'about.fact2': 'Lanci riusciti',
  'about.fact3': 'Satelliti Starlink',
  'about.fact4': 'Investitori nel mondo',
  'about.badge': 'Valutazione aziendale',

  // Services
  'services.tag': 'Cosa offriamo',
  'services.title1': 'I NOSTRI',
  'services.title2': 'SERVIZI',
  'services.sub': 'Gamma completa di servizi per investire comodamente e sicuramente nell\'IPO SpaceX',
  'services.s1.title': 'Gestione del portafoglio',
  'services.s1.desc': 'Gestione professionale del tuo portafoglio di investimenti. Monitoraggio continuo e ottimizzazione delle posizioni.',
  'services.s2.title': 'Protezione legale',
  'services.s2.desc': 'Tutti i contratti sono formalmente legali e protetti. Condizioni trasparenti, senza commissioni nascoste.',
  'services.s3.title': 'Analisi e previsioni',
  'services.s3.desc': 'Report settimanali del portafoglio. Analisi di mercato e raccomandazioni di esperti.',
  'services.s4.title': 'Manager personale',
  'services.s4.desc': 'Manager personale dedicato per tutto il periodo di investimento. Disponibile 24/7.',
  'services.s5.title': 'Assicurazione fondi',
  'services.s5.desc': 'I tuoi investimenti sono assicurati. Protezione garantita del capitale.',
  'services.s6.title': 'Prelievo rapido',
  'services.s6.desc': 'Ricevi il profitto entro 1 giorno lavorativo. Prelievo su conto bancario o wallet crypto.',

  // Contracts
  'contracts.tag': 'Pacchetti di investimento',
  'contracts.title1': 'SCEGLI IL TUO',
  'contracts.title2': 'CONTRATTO',
  'contracts.sub': 'Tre livelli di partecipazione all\'IPO SpaceX. Scegli il pacchetto adatto ai tuoi obiettivi',
  'contracts.duration': '2 giorni lavorativi',
  'contracts.profitlabel': 'Rendimento',
  'contracts.pure': 'profitto netto',
  'contracts.btn': 'SCEGLI PACCHETTO',
  'contracts.disclaimer': '* Rendimenti riferiti a 2 giorni lavorativi. Tutti i contratti sono legalmente formalizzati. Gli investimenti sono assicurati.',
  'contracts.popular': 'Popolare',
  'contracts.starter.f1': 'Soglia minima di ingresso',
  'contracts.starter.f2': 'Rendimento garantito 20%',
  'contracts.starter.f3': 'Pagamenti immediati',
  'contracts.starter.f4': 'Manager personale',
  'contracts.starter.f5': 'Registrazione legale',
  'contracts.starter.f6': 'Report settimanali',
  'contracts.advanced.f1': 'Rapporto rischio/rendimento ottimale',
  'contracts.advanced.f2': 'Rendimento garantito 30%',
  'contracts.advanced.f3': 'Pagamenti immediati',
  'contracts.advanced.f4': 'Manager personale VIP',
  'contracts.advanced.f5': 'Supporto legale esteso',
  'contracts.advanced.f6': 'Analisi di mercato in tempo reale',
  'contracts.advanced.f7': 'Assicurazione investimenti',
  'contracts.premium.f1': 'Rendimento massimo',
  'contracts.premium.f2': 'Rendimento garantito 50%',
  'contracts.premium.f3': 'Pagamenti immediati',
  'contracts.premium.f4': 'Manager dedicato 24/7',
  'contracts.premium.f5': 'Supporto legale e fiscale completo',
  'contracts.premium.f6': 'Accesso prioritario ai nuovi pacchetti',
  'contracts.premium.f7': 'Assicurazione + garanzia di rimborso',
  'contracts.premium.f8': 'Insight esclusivi sull\'IPO',

  // Profit
  'profit.tag': 'Risultati finanziari',
  'profit.title1': 'IL TUO',
  'profit.title2': 'PROFITTO',
  'profit.sub': 'Guarda come crescono i tuoi investimenti in soli 2 giorni lavorativi',
  'profit.calc.title': 'CALCOLATORE DI PROFITTO',
  'profit.calc.invested': 'Investito',
  'profit.calc.profit': 'Profitto',
  'profit.calc.total': 'Totale',
  'profit.chart.title': 'DINAMICA DI CRESCITA',
  'profit.chart.sub': 'Previsione per tutti i pacchetti, 2 giorni lavorativi',
  'profit.max.title': 'PROFITTO MASSIMO',
  'profit.max.sub': 'con pacchetto Premium 10 000 €',

  // Footer
  'footer.nav': 'NAVIGAZIONE',
  'footer.legal': 'INFORMAZIONI LEGALI',
  'footer.desc': 'Opportunità esclusiva di investire nell\'IPO SpaceX. Unisciti alla rivoluzione spaziale con rendimenti garantiti dal 20% al 50% in soli 2 giorni lavorativi.',
  'footer.terms': 'Termini di servizio',
  'footer.privacy': 'Informativa sulla privacy',
  'footer.tax': 'Informazioni fiscali',
  'footer.copy': '© 2025 SpaceX IPO. Tutti i diritti riservati.',
  'footer.disclaimer': 'Gli investimenti comportano rischi. I rendimenti passati non garantiscono risultati futuri.',

  // Live toast
  'toast.earned': 'ha guadagnato',
  'toast.in': 'in',
  'toast.days': '2 giorni lavorativi',

  // Video section
  'video.tag': 'Notizie spaziali',
  'video.title1': 'MISSIONE LUNARE',
  'video.title2': 'NASA',
  'video.sub': 'La NASA lancia la prima missione lunare con equipaggio in mezzo secolo — inizia una nuova era di esplorazione spaziale',
  'video.source': 'Euronews Bulgaria',
  'video.headline1': 'La NASA ha inviato astronauti sulla Luna con la missione Artemis II',
  'video.date1': 'Euronews Bulgaria · Aprile 2026',
  'video.headline2': 'Artemis II volerà verso la Luna per un tour di 10 giorni',
  'video.date2': 'Euronews Bulgaria · Aprile 2026',
  'video.headline3': 'La NASA lancia la prima missione lunare con equipaggio in mezzo secolo — reportage Darik News',
  'video.date3': 'Darik News · Aprile 2026',
  'video.readmore': 'Leggi l\'articolo su Darik News',
  'video.card1': 'SpaceX Starship — il razzo che alimenta la nuova missione lunare',
  'video.card2': 'Primo allunaggio con equipaggio dall\'Apollo 17 del 1972',
  'video.card3': 'Lo storico IPO SpaceX è direttamente legato al successo del programma lunare',
};